import { parsePhoneNumberFromString } from "libphonenumber-js";

export const getPhoneFieldValueFromRawNumber = (rawPhone) => {
  if (!rawPhone) return null;

  const phoneNumberObj = parsePhoneNumberFromString(rawPhone);

  if (phoneNumberObj) {
    const fullNumber = phoneNumberObj.number; 
    const countryCode = phoneNumberObj.countryCallingCode; 
    const iso2 = phoneNumberObj.country?.toLowerCase(); 

    return {
      phoneNumber: fullNumber.replace("+", ""),
      fullNumber: fullNumber,
      isPhoneNumberValid: true,
      countryCode: countryCode,
      countryData: {
        dialCode: countryCode,
        countryCode: iso2
      }
    };
  }

  return null;
};